import React from 'react';
import PropTypes from 'prop-types';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

class CountdownTimer extends React.Component {
    state = {
      secondsRemaining: this.props.secondsRemaining,
    };

  decrementSeconds = () => {
    if (this.state.secondsRemaining) {
      this.setState(state => ({
        secondsRemaining: state.secondsRemaining - 1,
      }));
    }
  };

  formatSeconds = seconds => {
    const date = new Date(0);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 8);
  }

  componentDidMount() {
    this.interval = setInterval(this.decrementSeconds, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { state, props } = this;
    const time = this.formatSeconds(state.secondsRemaining);
    return props.description
      ? replaceTextWithValues(props.description, { time })
      : time;
  }
}

CountdownTimer.propTypes = {
  description: PropTypes.string.isRequired,
  secondsRemaining: PropTypes.number.isRequired,
};

export default CountdownTimer;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CountdownTimer/CountdownTimer.js